import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    path: '/action-tracker',
    // component: ShellApplication,
    meta: {
      requiresAuth: true,
      module: 'action-tracker',
      layout: 'home',
      allowedRoles: [...allowed.action_tracker.roles],
    },
    component: () =>
      import(
        '@/modules/action-tracker/containers/action-tracker-root.container.vue'
      ),
    children: [
      {
        path: '',
        name: 'Action Tracker',
        component: () =>
          import(
            '@/modules/action-tracker/containers/action-tracker.container.vue'
          ),
        children: [
          {
            path: 'task-detail/:id',
            name: 'task-detail',
            component: () =>
              import(
                '@/modules/action-tracker/containers/action-tracker-task-detail.container.vue'
              ),
          },
        ],
      },
      {
        path: 'action-plan',
        component: () =>
          import(
            '@/modules/action-tracker/containers/action-plan/index-page.vue'
          ),
        children: [
          {
            path: ':id',
            name: 'action-plan-details',
            component: () =>
              import(
                '@/modules/action-tracker/components/action-plan-wrapper.vue'
              ),
          },
        ],
      },
    ],
  },
]

export default index
